define(function (require, exports, module) {
    var BaseApiHeartbeatItem = require('./BaseApiHeartbeatItem');
    var Superclass;

    function ApiHeartbeatItem (id, gameItem) {
        Superclass.constructor.call(this, id, gameItem);
    }

    BaseApiHeartbeatItem.spawn(ApiHeartbeatItem).define({
        init: function () {
            Superclass.init.call(this);
            this.executeHeartbeat();
        }
    });

    Superclass = ApiHeartbeatItem.superclass;

    return ApiHeartbeatItem;
});
